const storagePrefix = '_internal_neo_';

/**
 * 设置 sessionStorage
 * @param key
 * @param value
 * @description 对应重构前 util.setSession
 */
export function setSessionStorage(key: string, value: any = '1'): void {
  if (!key) {
    return;
  }
  try {
    sessionStorage.setItem(`${storagePrefix}${key}`, value);
  } catch (e) {
    // TODO 异常埋点
  }
}

/**
 * sessionStorage 是否存在指定键（值）
 * @param key
 * @param value
 * @description 对应重构前 util.hasSession
 */
export function hasSessionStorage(key: string, value: any = '1'): boolean {
  let val = '';
  try {
    val = sessionStorage.getItem(`${storagePrefix}${key}`) || '';
  } catch (e) {
    // TODO 异常埋点
  }
  return !!val && val === value;
}
export function getSessionStorage(key: string): string | null {
  let val = null;
  try {
    val = sessionStorage.getItem(`${storagePrefix}${key}`);
  } catch (e) {
    // TODO 异常埋点
  }
  return val;
}
export default {
  setSessionStorage,
  hasSessionStorage,
  getSessionStorage,
};
